export default __webpack_public_path__ + "static/media/lawn-doctors-reviews-background.4a077595.jpg";